import { defineStore } from 'pinia';

interface State {
  loading: boolean;
}

export const useLoaderStore = defineStore('loader', {
  state: (): State => ({
    loading: false,
  }),
});
